import { useLocation } from "react-router-dom";
import Navbar from "src/components/common/Navbar";
import Footer from "src/components/Home/Footer";
import ChatWidget from "src/components/Chat/ChatWidget";

const AppLayout = ({ children }) => {
  const location = useLocation();

  // Routes without navbar
  const noNavbarRoutes = [
    "/forgot-password",
    "/reset-password",
    "/chat",
    "/conversations",
  ];

  // Footer hidden routes
  const noFooterRoutes = [...noNavbarRoutes, "/dashboard"];

  const showNavbar = !noNavbarRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  const showFooter = !noFooterRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  return (
    <>
      {showNavbar && <Navbar />}
      <main>{children}</main>
      {showFooter && <Footer />}
      {/* <ChatWidget /> */}
    </>
  );
};

export default AppLayout;
